// extracted by mini-css-extract-plugin
module.exports = {"buttons":"EditAreaModal_buttons__vjXuY","error":"EditAreaModal_error__Pmbfq","error-msg":"EditAreaModal_error-msg__sgVXf"};